import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './SetpointsList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { initialSetpointsState } from '../../reducers/initialState';
import Banner from '../Banner/Banner';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useParams, Link } from 'react-router-dom';
import Pagination from '../Pagination/Pagination';
import { DEFAULT_PAGE_SIZE, SETPOINTS_TYPE, FLOWSEQUENCE_TYPE, SERVICE_TYPE, ModelCategoryPermission } from '../../constants';
import SetpointsListTable from './SetpointsListTable';
import ModelCategoryConfigurationContentTemplate from '../ModelCategoryTab/ModelCategoryConfigurationContentTemplate';
import { WidgetVisibility, IsWidgetAccessible } from '../../utils/widgetManager';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import SearchBar from '../SearchBar/SearchBar';
import Cookies from 'js-cookie';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb'
import { getModelCategoryPermission, sortSetpoints } from '../../utils';



const breadcrumbItems = [
  { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
  { label: <FormattedMessage id="setpointsManagement.setpoints" defaultMessage="Setpoints" /> } // Last item has no href (current page)
];

const SetpointsList = ({
  getSetpoints,
  setCurrentPage,
  setpoints = {
    setpoints: []
  },
  saveSetpoints,
  intl,
  userProfileWidgets,
  currentTimezone,
  setSetpointsChange,
  userModelCategories,
  resetSetpoints
}) => {
  let filter = setpoints.filter || '';
  let offset = setpoints.offset || 0;
  let limit = setpoints.limit || 1000;
  let { ModelCategoryId } = useParams();

  const [searchFilter, setSearchFilter] = useState('');
  const [filterType, setFilterType] = useState('0');
  const [active, setActive] = useState(false);
  const [setpointId, setSetpointId] = useState(0);

  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  // if (setpoints.isOpSuccessful) {
  //   setSetpointsChange({
  //     selectedSetpoints: {
  //       ...initialSetpointsState.setpoints
  //     }
  //   });
  //   getSetpoints(offset, limit, filter);
  // }

  useEffect(() => {
    return () => {
      setSetpointsChange(initialSetpointsState.setpoints);
    };
  }, [setSetpointsChange]);

  useEffect(() => {
    return () => {
      resetSetpoints({ ...initialSetpointsState });
    };
  }, []);


  useEffect(() => {
    getSetpoints(ModelCategoryId, offset, limit, filter);
  }, [getSetpoints, setSetpointsChange, offset, ModelCategoryId, limit, filter, setpoints.isOpSuccessful]);

  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };

  const searchHandler = value => {
    setSearchFilter(value);
    setCurrentPage(1);
  };

  const onTypeChange = e => {
    setFilterType(e.value);
    setCurrentPage(1);
  };

  const filteredResults = () => {
    let filteredList = setpoints.setpoints;

    if (filterType !== '0') {
      filteredList = filteredList.filter(function (item) {
        return item.Type === filterType;
      });
    }

    if (searchFilter !== '') {
      filteredList = filteredList.filter(function (item) {
        return item.Name.toLowerCase().includes(searchFilter.toLowerCase());
      });
    }
    return filteredList;
  };

  const typeOptions = () => {
    let statusData = [];

    statusData.push({
      label: <FormattedMessage id="setpointsManagement.showAll" defaultMessage="Show: All" />,
      value: '0'
    });

    statusData.push({
      label: <FormattedMessage id="setpointsManagement.setpoint" defaultMessage="setpoint" />,
      value: SETPOINTS_TYPE
    });

    statusData.push({
      label: <FormattedMessage id="setpointsManagement.flowSequence" defaultMessage="Flow Sequence" />,
      value: FLOWSEQUENCE_TYPE
    });

    statusData.push({
      label: <FormattedMessage id="setpointsManagement.serviceType=" defaultMessage="Service Type" />,
      value: SERVICE_TYPE
    });

    return statusData;
  };

  const onDeleteClick = setpointId => {
    setActive(true);
    setSetpointId(setpointId);
  };

  const deleteSetpoints = () => {
    let saveData = { SetpointId: setpointId, ModelCategoryId: ModelCategoryId };
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 1;
    saveData.MarkAsDeleted = true;
    saveSetpoints(saveData, 'SETPOINTSDELETE');
  };

  const handleConfirm = () => {
    deleteSetpoints();
    handleClose();
  };

  const handleClose = () => setActive(false);

  const dialogTitle = intl.formatMessage({
    id: 'setpointsManagement.confirmDeleteSetpoint',
    defaultMessage: 'Are you sure you want to delete the setpoint?'
  });

  let messageId = (setpoints && setpoints.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const isChangedAllowed = IsWidgetAccessible(userProfileWidgets, 'SETPOINTSUPDATE');
  const isDeleteAllowed = IsWidgetAccessible(userProfileWidgets, 'SETPOINTSDELETE');
  const isDuplicate = IsWidgetAccessible(userProfileWidgets, 'SETPOINTSCLONE');

  let isModelCategoryOwner = getModelCategoryPermission(userModelCategories, ModelCategoryId, ModelCategoryPermission.Owner)




  return (
    <div className={s.setpoints}>
      {setpoints.isLoading && <LoadingSpinner />}
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <Banner
        failureText={messageText}
        showBanner={setpoints.showBanner}
        status={setpoints.isOpSuccessful}
        successText={messageText}
      />

      <ModelCategoryConfigurationContentTemplate selectedPage="setpoints" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper} style={WidgetVisibility(userProfileWidgets, 'SETPOINTSLIST')}>
          <div className={s.setpointsHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="setpointsManagement.setpoints" defaultMessage="Setpoints" />
              <span data-unittest="setpointsDataCount" className={s.circle}>
                {setpoints.setpoints.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <Row className={s.titleRows}>
            <Col sm={4} lg={3}>
              <div className={s.topColumns}>
                <SearchBar
                  searchHandler={searchHandler}
                  clearSearchInVisible={false}
                  initialText={searchFilter}
                  placeHolderTextId="setpointsManagement.search"
                />
              </div>
            </Col>
            <Col sm={4} lg={3}>
              <div className={s.topColumns}>
                <Dropdown
                  id="drpStatusId"
                  dataArray={typeOptions()}
                  controlData={{
                    placeholderText: <FormattedMessage id="setpointsManagement.showAll" defaultMessage="Show: All" />,
                    customClassName: ''
                  }}
                  onDropdownChange={onTypeChange}
                  selectedOption={typeOptions().filter(option => option.value === filterType)}
                  disabled={false}
                />
              </div>
            </Col>
            <Col sm={4} lg={6}>
              {isModelCategoryOwner && <Link to={`/operational-setup/model-category-configuration/${ModelCategoryId}/setpoints/0`}>
                <Button className={s.addbutton} style={WidgetVisibility(userProfileWidgets, `SETPOINTSADDNEW`)}>
                  + <FormattedMessage id="setpointsManagement.addNew" defaultMessage="+ ADD NEW" />
                </Button>
              </Link>}
            </Col>
          </Row>

          <div className="">
            <Pagination
              data={sortSetpoints(filteredResults())}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={setpoints.currentPage}
            >
              <SetpointsListTable
                ModelCategoryId={ModelCategoryId}
                onDeleteClick={onDeleteClick}
                deleteAllowed={isDeleteAllowed}
                duplicateAllowed={isDuplicate}
                changeAllowed={isChangedAllowed}
                currentTimezone={currentTimezone}
                isModelCategoryOwner={isModelCategoryOwner}
              />
            </Pagination>
          </div>
        </div>
      </ModelCategoryConfigurationContentTemplate>
    </div>
  );
};


SetpointsList.propTypes = {
  getSetpoints: PropTypes.func.isRequired,
  saveSetpoints: PropTypes.func.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  setPageFilter: PropTypes.func.isRequired,
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(SetpointsList);
